import Vue from "vue/dist/vue.js";
import Router from "vue-router";

import LangValidation from "./middleware/lang";
import AuthValidation from "./middleware/auth";

import { site } from "./site";
import { registration, anketa } from "./registration";
import { cabinet } from "./cabinet";

import Layout from "@/views/layout-site";
import LayoutCabinet from "@/views/cabinet/layout-cabinet";
import LayoutRegistration from "@/views/registration/layout-registration";
import Login from "@/views/cabinet/auth/login";
import ForgotPassword from "@/views/cabinet/auth/forgotPassword";
import ErrorPage from "@/views/404";

import { TOGGLE_LOADER } from "../storage/mutations";

Vue.use(Router);

/* eslint-disable no-new */
const router = new Router({
    mode: "history",

    routes: [
        {
            path: "/:lang?",
            name: "Lang",
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    component: Layout,
                    children: [
                        // Роуты сайта - site.js
                        ...site,
                    ],
                },
                {
                    path: "anketa",
                    name: "Anketa",
                    component: LayoutRegistration,
                    children: [
                        // Роуты для анкеты - registration.js
                        ...registration,
                        ...anketa,
                    ],
                },
                {
                    path: "cabinet",
                    name: "Cabinet",
                    component: LayoutCabinet,
                    children: [
                        // Роуты личного кабинета - cabinet.js
                        ...cabinet,
                    ],
                },
                {
                    path: "login",
                    name: "LoginLayout",
                    component: LayoutRegistration,
                    children: [
                        {
                            path: "",
                            name: "Login",
                            component: Login,
                        },
                    ],
                },
                {
                    path: "forgot-password",
                    name: "ForgotPasswordLayout",
                    component: LayoutRegistration,
                    children: [
                        {
                            path: "",
                            name: "ForgotPassword",
                            component: ForgotPassword,
                        },
                    ],
                },
            ],
        },
        {
            name: "Error",
            path: "/404.html",
            component: ErrorPage,
        },
    ],

    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    let _this = router;

    LangValidation(to, from)
        .then(function (response) {
            router.app.$locale = response.lang;
            return AuthValidation(to, from, router.app);
        })
        .then(response => {
            _this.app.$store.commit(TOGGLE_LOADER, { state: true });
            next();
        })
        .catch(function (response) {
            _this.app.$store.commit(TOGGLE_LOADER, { state: true });

            // TODO: Залогировать ошибку
            next(response.data);

            _this.app.$store.commit(TOGGLE_LOADER, { state: false });
        });
});

router.afterEach((to, from) => {
    router.app.$store.commit(TOGGLE_LOADER, { state: false });
});

export default router;